/**
 * @file AssetTemplatesPanel.js
 * @description This panel populates the templates associated with an asset.
 */

import { useState, useEffect } from 'react';
import styles from '../AssetDrawer.module.scss';
import { useNavigate } from 'react-router';
import { SecurityAttributes } from '../../../utils/data/enums';
import { useAuthContext } from '../../../store/AuthContext';
import { getContentType } from '../../helpers/getContentType';
import { ROUTES } from '../../../constants/routes';
import { getText } from '../../../i18n';
const AssetTemplatesPanel = ({ asset }) => {
    const navigate = useNavigate();
    const { hasAttribute } = useAuthContext();
    const [sortedTemplates, setSortedTemplates] = useState([]);

    useEffect(() => {
        if (asset) {
            let sortedTemplatesArray = [...asset.containers];
            sortedTemplatesArray.sort((a, b) => b.order - a.order);
            setSortedTemplates(sortedTemplatesArray);
        }
    }, [asset]);

    const getName = index => {
        let name = '';
        name = sortedTemplates[index].name;
        return name;
    };

    const getId = index => {
        let id = 1;
        id = sortedTemplates[index].id;
        return id;
    };

    const getType = index => {
        let type = '';
        type = getContentType(sortedTemplates[index].type);
        return type;
    };

    return (
        <>
            <p className={styles.portalsPanelTitle}>{getText('msg_f25b700ed9f0')}</p>
            <div className={styles.assetPortalsPanel}>
                <div className={styles.portalsContent}>
                    {sortedTemplates.map((event, index) => (
                        <div key={event.id} className={styles.portalsEntry}>
                            <div className={styles.portalsHeader}>
                                <div style={{ marginBottom: '10px' }}>
                                    <span className={styles.portalsName}>
                                        {getName(index)}
                                    </span>
                                    {hasAttribute(
                                        SecurityAttributes.TemplatesFullAccess
                                    ) && (
                                            <p
                                                className={styles.heading}
                                                onClick={() =>
                                                    navigate(ROUTES.TEMPLATES_VIEW, {
                                                        state: {
                                                            id: getId(index),
                                                        },
                                                    })
                                                }
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#007BFF',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {getText('msg_69bd4ef9fbd0')}
                                            </p>
                                        )}
                                </div>
                                <span
                                    className={styles.portalsStatus}
                                    style={{ marginLeft: '4px' }}
                                >
                                    {getText('msg_822024a7b7d7')} {getType(index)}
                                </span>
                                <hr />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default AssetTemplatesPanel;
